import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Orientacion from '.';

type Props = RouteComponentProps<{}>;

const OrientacionPrincipal: React.FunctionComponent<Props> = props => {
    return (
        <div>
            <Orientacion />
        </div>
    );
};

export default OrientacionPrincipal;



// WEBPACK FOOTER //
// ./src/modulos/Orientacion/OrientacionPrincipal.tsx